import React from 'react';
import { observer } from 'mobx-react';
import { Modal } from 'semantic-ui-react';
import Customers from './Customers';
import CustomerList from './CustomerList';

const CustomerSelector = ({ isOpen, onClose, onSelectItem }) => {
  return (
    <Modal size='small' open={isOpen} 
      closeIcon onClose={onClose}
      closeOnDimmerClick={false}>
      <Modal.Header>Select Customer</Modal.Header>
      <Modal.Content style={{ height: '380px' }}>
        <Customers
          fixedHeight={300} 
          onClickItem={onSelectItem} 
          ListComponent={CustomerList}
        />
      </Modal.Content>
    </Modal>
  )
}
 
export default observer(CustomerSelector);


// WEBPACK FOOTER //
// ./src/components/customers/CustomerSelector.js